import { Component, NgZone, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { PersonalNotificationsService } from '../personal-notifications.service';
import { NewsFeedService } from '@fi-app/news-feed/news-feed.service';
import { FiSignalRService } from '@fi-shared/fi-signal-r/fi-signal-r.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { FiProfileSizes } from '@fi-shared/profile-icon/profile-icon.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FiSignalRHelperService } from '@fi-shared/fi-signal-r/fi-signal-r-helper.service';
import { FiItemUpdatedEventType } from '@fi-shared/fi-signal-r/fi-item-update-event-type';
import { ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-personal-notifications-icon',
    templateUrl: './personal-notifications-icon.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./personal-notifications-icon.component.scss'],
    host: { class: 'fi-personal-notifications-icon' },
    standalone: false,
})
export class PersonalNotificationsIconComponent implements OnInit, OnDestroy {
    newNotificationsCount: number = 0;
    showNotificationsList: boolean = false;

    constructor(
        public fiPersonalNotificationsService: PersonalNotificationsService,
        private fiSignalRHelperService: FiSignalRHelperService,
        private ngZone: NgZone,
        private newsFeedService: NewsFeedService,
        private fiSignalRService: FiSignalRService,
        private userDataService: FiUserDataService,
        private detectDevices: DetectDevicesService,
    ) {}

    ngOnInit() {
        this.fiSignalRHelperService.initialUnseenPersonalNotificationsCount
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((data) => {
                this.newNotificationsCount = data;
            });

        this.fiSignalRService.itemUpdatedEvent.subscribe((data) => {
            if (
                data.EventType === FiItemUpdatedEventType.Feed &&
                data.ObjectType === ObjectTypes.Notification &&
                data.EventByUserId !== this.userDataService.getUserId()
            ) {
                this.updateNewPersonalNotificationsCount();
            }
        });
    }

    private updateNewPersonalNotificationsCount() {
        this.fiPersonalNotificationsService.getNewPersonalNotificationsCount().then((response) => {
            this.newNotificationsCount = response;
        });
    }

    hidePersonalNotificationList() {
        this.showNotificationsList = false;
    }

    togglePersonalNotifications() {
        if (!this.showNotificationsList) setTimeout(() => (this.showNotificationsList = true));
    }

    afterPersonalNotificationClick(listItemCategory) {
        if (listItemCategory == 0 && this.newNotificationsCount > 0) this.newNotificationsCount--;

        this.showNotificationsList = false;
    }

    getUserProfile() {
        return this.userDataService.getUserProfile();
    }

    getProfileIconSize() {
        return this.detectDevices.isMobilePhone() ? FiProfileSizes.Size20px : FiProfileSizes.Size32px;
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
